import React from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Download from 'assets/images/Dashboard/dowload.svg';
import Shimmer from 'components/commom/Shimmer';

const RequestDetailFooter = () => {
  const requestDetailReducer = useSelector(
    (state) => state?.requestDetailReducer?.loading
  );

  const requestDetail = useSelector(
    (state) => state?.requestDetailReducer?.users?.data
  );

  return (
    <div>
      <Row className="m-0 p-0">
        <Col sm={12} className="p-0">
          <div className="fs-18 family_outfit_semiBold_600 lh-2268 fc-292D32 pt-28">
            Professional Details
          </div>
          <Row className="pt-24 m-0">
            <Col sm={6} lg={3} className="p-0 m-0">
              <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                Practice Name
              </div>
              <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                {requestDetailReducer ? (
                  <Shimmer width="250px" height="20px" marginTop={'8px'} />
                ) : (
                  requestDetail?.doctor_practice_info?.[0]?.practice_name
                )}
              </div>
            </Col>
            <Col sm={6} lg={3} className="p-0 m-0">
              <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                Select sub-practices
              </div>
              {requestDetail?.doctor_practice_info?.[0]
                ?.doctor_sub_practice_info &&
                requestDetail?.doctor_practice_info?.[0]
                  ?.doctor_sub_practice_info.length > 0 &&
                requestDetail?.doctor_practice_info?.[0]?.doctor_sub_practice_info.map(
                  (item, index) => {
                    return (
                      <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                        {requestDetailReducer ? (
                          <Shimmer
                            width="250px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          item?.sub_practice
                        )}
                      </div>
                    );
                  }
                )}
            </Col>
            <Col sm={6} lg={3} className="p-0 m-0">
              <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                State Code
              </div>
              {requestDetail?.doctor_practice_info?.[0]
                ?.doctor_sub_practice_info &&
                requestDetail?.doctor_practice_info?.[0]
                  ?.doctor_sub_practice_info.length > 0 &&
                requestDetail?.doctor_practice_info?.[0]?.doctor_sub_practice_info.map(
                  (item, index) => {
                    return (
                      <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                        {requestDetailReducer ? (
                          <Shimmer
                            width="250px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          item?.state_code?.name
                        )}
                      </div>
                    );
                  }
                )}
            </Col>
            <Col sm={6} lg={3} className="p-0 m-0">
              <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                Fee per session
              </div>
              {requestDetail?.doctor_practice_info?.[0]
                ?.doctor_sub_practice_info &&
                requestDetail?.doctor_practice_info?.[0]
                  ?.doctor_sub_practice_info.length > 0 &&
                requestDetail?.doctor_practice_info?.[0]?.doctor_sub_practice_info.map(
                  (item, index) => {
                    return requestDetailReducer ? (
                      <Shimmer width="250px" height="20px" marginTop={'8px'} />
                    ) : (
                      <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                        $ {item?.fee_per_session}
                      </div>
                    );
                  }
                )}
            </Col>
          </Row>
          <Row className="pt-24 m-0">
            <Col sm={12} lg={6} className="p-0 m-0">
              <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                State License
              </div>
              {requestDetail?.doctor_practice_info?.[0]
                ?.doctor_sub_practice_info &&
                requestDetail?.doctor_practice_info?.[0]
                  ?.doctor_sub_practice_info.length > 0 &&
                requestDetail?.doctor_practice_info?.[0]?.doctor_sub_practice_info.map(
                  (item, index) => {
                    return (
                      <>
                        <div className="pt-8 flex" key={index}>
                          <a
                            href={item?.state_license || '#'}
                            download={
                              item?.state_license
                                ? item?.state_license.split('/').pop()
                                : 'license'
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="fs-16 lh-201 fc-5B88E9 family_outfit_regular_400 cursor-pointer underline underline-offset-4 flex"
                          >
                            {requestDetailReducer ? (
                              <Shimmer
                                width="300px"
                                height="20px"
                                marginTop={'8px'}
                              />
                            ) : (
                              item?.state_license && (
                                <>
                                  {item?.state_license.split('/').pop()}

                                  <Image
                                    src={Download}
                                    alt="icon"
                                    className="pl-2"
                                  />
                                </>
                              )
                            )}
                          </a>
                        </div>
                      </>
                    );
                  }
                )}
            </Col>
            {requestDetail?.address?.address_proof !== '' && (
              <Col sm={12} lg={6} className="p-0 m-0">
                <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                  Proof Of Address
                </div>

                <div className="pt-8 flex">
                  <a
                    href={requestDetail?.address?.address_proof || '#'}
                    download={
                      requestDetail?.address?.address_proof
                        ? requestDetail?.address?.address_proof.split('/').pop()
                        : 'license'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fs-16 lh-201 fc-5B88E9 family_outfit_regular_400 cursor-pointer underline underline-offset-4 flex"
                  >
                    {requestDetailReducer ? (
                      <Shimmer width="300px" height="20px" marginTop={'8px'} />
                    ) : (
                      requestDetail?.address?.address_proof && (
                        <>
                          {requestDetail?.address?.address_proof
                            .split('/')
                            .pop()}
                          <Image src={Download} alt="icon" className="pl-2" />
                        </>
                      )
                    )}
                  </a>
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
      <Row className="m-0 p-0">
        <Col sm={12} className="p-0">
          <div className="fs-18 family_outfit_semiBold_600 lh-2268 fc-292D32 pt-28">
            Contract Details
          </div>
        </Col>
        <Row className="pt-24 m-0">
          <Col sm={6} lg={3} className="p-0 m-0">
            <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
              Contract
            </div>
            <a
              href={requestDetail?.contract_url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="fs-16 lh-201 fc-5B88E9 family_outfit_regular_400 cursor-pointer underline underline-offset-4 flex"
            >
              {requestDetailReducer ? (
                <Shimmer width="250px" height="20px" marginTop={'8px'} />
              ) : (
                requestDetail?.contract_url && (
                  <>
                    {requestDetail.contract_url.split('contract/').pop()}
                    <Image src={Download} alt="icon" className="pl-2" />
                  </>
                )
              )}
            </a>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default RequestDetailFooter;
